export const HIDDEN_COLUMNS_KEY = "livecalls.hidden-columns.v1";

/** Read the persisted hidden-column keys. Tolerates missing/corrupt storage → []. */
export function loadHiddenColumns(): string[] {
  try {
    const raw = localStorage.getItem(HIDDEN_COLUMNS_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((k) => typeof k === "string")) {
      return parsed as string[];
    }
    return [];
  } catch {
    return [];
  }
}

/** Persist the hidden-column keys. Swallows storage errors (private mode, quota). */
export function saveHiddenColumns(keys: string[]): void {
  try {
    localStorage.setItem(HIDDEN_COLUMNS_KEY, JSON.stringify(keys));
  } catch {
    /* ignore */
  }
}

/** Add the key if absent, remove it if present. Returns a new array (no mutation). */
export function toggleHidden(hidden: string[], key: string): string[] {
  return hidden.includes(key) ? hidden.filter((k) => k !== key) : [...hidden, key];
}

/** Registry columns minus the hidden set; pinned columns are never dropped; order preserved. */
export function visibleColumns<T extends { key: string; pinned?: boolean }>(
  all: T[],
  hidden: string[],
): T[] {
  return all.filter((c) => c.pinned || !hidden.includes(c.key));
}
